import { BRAIN_FILES } from "@/data/brain";
import { InfoNote } from "@/components/InfoNote";

export function FileWindow({ fileId }: { fileId?: string }) {
    const file = BRAIN_FILES.find((f) => f.id === fileId);
    if (!file) {
        return <p className="font-mono text-sm text-inkfaint">file not found. it may have overthought itself out of existence.</p>;
    }
    return (
        <div data-testid="file-window">
            {file.kind === "final-egg" && <span className="badge border-butterd bg-butter/40">reward file — you earned this</span>}
            {file.paragraphs.map((p, i) =>
                p === "" ? (
                    <div key={i} className="h-2" />
                ) : (
                    <p
                        key={i}
                        className={`mt-2 whitespace-pre-wrap leading-relaxed ${
                            file.kind === "final-egg" ? "text-[13.5px] font-medium text-ink" : "text-[13px] text-inksoft"
                        }`}
                    >
                        {p}
                    </p>
                ),
            )}
            {file.note && (
                <div className="mt-4">
                    <InfoNote text={file.note} testId={`file-${file.id}-note`} />
                </div>
            )}
        </div>
    );
}
